<template>
    <div>
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <h3 class="mb-0">
                {{ data.type }} <span v-if="data.item_year != null">(Tahun {{ data.item_year }})</span>
                <b-badge class="ml-2" :variant="parseStatus(data.status, 0)">{{ parseStatus(data.status, 1) }}</b-badge>
            </h3>
            {{ data.kind }} - {{ data.brand }}<br />
            {{ data.status == 55 ? "Request hilang" : "Approval" }} oleh <strong>{{ data.approved_by }}</strong> pada {{
            $helper.parseDate(data.approved_at) }}, {{ $helper.parseHourMinute(data.approved_at) }}<br />
            <div v-if="data.note_lost != null">Keterangan hilang: {{ data.note_lost }}</div>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>No. Faktur</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="6">
                    <strong>Gudang</strong><br />
                    {{ data.warehouse || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>Asal Proses</strong><br />
                    {{ data.origin_type || "Original" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>Kloter Pengiriman</strong><br />
                    {{ $helper.parseDate(data.created) }}
                </b-col>
                <b-col md="6" v-if="!itemFlags.isLMScan">
                    <strong>Kadar</strong><br />
                    {{ data.purity || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="itemFlags.isLMScan">
                <b-col md="6">
                    <strong>Tahun</strong><br />
                    {{ data.year || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="!itemFlags.isLMScan">
                <b-col md="6">
                    <strong>Berat Kotor</strong><br />
                    {{ data.dry_weight || "-" }} gr
                </b-col>
                <b-col md="6">
                    <strong>Potongan Berat</strong><br />
                    {{ data.weight_reduction || "-" }} gr
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="itemFlags.isPerhiasan">
                <b-col md="md">
                    <strong>Ada Cap</strong> <br />
                    {{ hasMark }}
                </b-col>
                <b-col md="6">
                    <strong>Merk Cap Emas</strong><br />
                    {{ data.gold_mint_mark || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="itemFlags.isPerhiasan">
                <b-col md="6">
                    <strong>Jumlah Keping</strong><br />
                    {{ data.piece_count || "-" }} pcs
                </b-col>
                <b-col md="6" >
                    <strong>Tipe Emas</strong><br />
                    {{ data.gold_type || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>Berat Bersih</strong><br />
                    {{ data.net_weight || "-" }} gr
                </b-col>
                <b-col md="6">
                    <strong>No. Faktur</strong><br />
                    {{ data.no_faktur_pei || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                 <b-col md="6">
                    <strong>No. Faktur Original</strong><br />
                    {{ data.no_faktur_original || "-" }}
                </b-col>
                <b-col md="6" v-if="itemFlags.isPerhiasan">
                    <strong>Cap Getok</strong><br />
                    {{ data.is_stamped ? "Ada" : "Tidak Ada" }}
                </b-col>
                <b-col md="6" v-else-if="!itemFlags.isPerhiasan && data.status == 3">
                    <strong>Diskon Kadar</strong><br />
                    {{ data.discount_purity || "-" }}
                </b-col>
            </b-row>
             <b-row class="mt-3" v-if="data.status == 3 && itemFlags.isPerhiasan">
                 <b-col md="6">
                    <strong>Diskon Kadar</strong><br />
                    {{ data.discount_purity || "-" }}
                </b-col>
            </b-row>
            <div class="mt-3">
                <strong>HARGA TERJUAL</strong><br />
                <strong>Rp. {{ isSold(data.status) ? $helper.formatThousand(data.sold_price) : "-" }}</strong>
            </div>
            <b-row class="mt-3" v-if="data.logs && data.logs.length != 0">
                <b-col md="12">
                    <strong>Riwayat Inventaris</strong><br />
                    <strong>Riwayat Inventory</strong><br />
                    <ul>
                        <li v-for="(item, index) in data.logs" :key="index">
                            <div v-if="item.type == 1">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - PENJUALAN
                                dengan No. Faktur <strong>{{ item.no_faktur }} ({{ item.description }})</strong> sebesar
                                Rp. {{ $helper.formatThousand(item.metadata.total) }}.
                            </div>
                            <div v-else-if="item.type == 2">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - RETUR dengan
                                No. Faktur <strong>{{ item.no_faktur }}</strong> dengan alasan: {{ item.metadata.reason }}
                            </div>
                            <div v-else-if="item.type == 3">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - INVENTARIS
                                dengan No. Faktur <strong>{{ item.no_faktur }}</strong> dari Gudang <strong>{{ item.description }}</strong>.
                            </div>
                            <div v-else-if="item.type == 4">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - INVOICE VOID dengan
                                No. Faktur <strong>{{ item.no_faktur }}</strong>
                            </div>
                            <div v-else-if="item.type == 40">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - LEBUR EMAS
                                dengan No. Batch <strong>{{ item.no_faktur }}</strong> sebesar
                                Rp. {{ $helper.formatThousand(item.metadata.melted_value) }}.
                            </div>
                            <div v-else-if="item.type == 60">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - KOREKSI HARGA JUAL
                                pada No. Faktur <strong>{{ item.metadata.invoice_no_faktur }}</strong>:
                                Rp. {{ $helper.formatThousand(item.metadata.old) }} → Rp. {{ $helper.formatThousand(item.metadata.new) }}
                            </div>
                            <div v-else>
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - {{ item.label }}
                                dengan No. Faktur <strong>{{ item.no_faktur }}</strong>
                                <span v-if="item.description"> — {{ item.description }}</span>
                            </div>
                        </li>
                    </ul>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isFetching: false,
            isSubmitting: false,

            data: {
                logs: []
            },

        }
    },
    props: {
        id: { type: Number, required: true }
    },
    methods: {

        init() {

            this.initStatus = 0
            this.$axios.get(`inventory/gold/${this.id}`).then(res => {

                this.initStatus = 1
                this.data = res.data.data

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.initStatus = -1
                })

        },


        parseStatus(status, index) {
            switch (status) {
                case 2: return ["dark", "READY"][index]
                case 3: return ["success", "TERJUAL"][index]
                case 4: return ["warning", "RETUR"][index]
                case 5: return ["danger", "HILANG"][index]
                case 6: return ["primary", "KIRIM BALIK PGI"][index]
                case 7: return ["light", "DRAFT"][index]
                case 55: return ["dark", "REQUEST HILANG"][index]
                case 8: return ["dark", "REQUEST RESET"][index]
                case 9: return ["primary", "REQUEST MOVE"][index]
                case 10: return ["primary", "INVENTARIS"][index]
                case 66: return ["primary", "REQUEST KIRIM BALIK PGI"][index]
                case 11: return ["primary", "REQUEST INVENTARIS"][index]
                case 12: return ["danger", "DILEBUR"][index]
                case 13: return ["danger", "DIMURNIKAN"][index]
                default: return ["light", "-"][index]
            }
        },
        isSold(status) {
            return status === 3 || status == 12; // sold or melted
        }

    },
    computed: {
        itemFlags() {
            return {
                isLMRetro: this.data.item_kind_id === 261,
                isLMScan: this.data.item_kind_id === 251,
                isPerhiasan: this.data.item_kind_id === 257,
            };
        },
        hasMark() {
            return this.data.has_mark ? "Ada" : "Tidak Ada";
        }
    },
    created() {
        this.init()
    }
}
</script>

<style></style>
